/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersnameplaceholder2Inputs */

const en_partnersnameplaceholder2 = /** @type {(inputs: Partnersnameplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Anna Berger or Wirtschaftskammer Linz`)
};

const de_partnersnameplaceholder2 = /** @type {(inputs: Partnersnameplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Anna Berger oder Wirtschaftskammer Linz`)
};

/**
* | output |
* | --- |
* | "e.g. Anna Berger or Wirtschaftskammer Linz" |
*
* @param {Partnersnameplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersnameplaceholder2 = /** @type {((inputs?: Partnersnameplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersnameplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersnameplaceholder2(inputs)
	return de_partnersnameplaceholder2(inputs)
});
export { partnersnameplaceholder2 as "partnersNamePlaceholder" }